import { z } from 'zod';
import { AgentProviderSpec } from './llm-providers.js';
/**
 * The config drafter (task 47): an editor describes a question or rule in plain words; the agent drafts
 * its body; the core checks it with the same validation as any draft and asks the agent once to repair
 * what fails. Nothing is saved: the editor creates the draft, and publishing is the usual maker-checker
 * release. Draft → Validate → Approve → Publish.
 */
export const DRAFTABLE_KINDS = ['question', 'rule'];
export const DraftConfig = z.strictObject({
    kind: z.enum(DRAFTABLE_KINDS),
    request: z.string().trim().min(10, 'say a little more about what you need').max(2000),
});
/** What the core sends the agent (`DraftRequest` in the Python service). */
export const ConfigDraftRequest = z.strictObject({
    tenant_id: z.string(),
    kind: z.enum(DRAFTABLE_KINDS),
    request: z.string().min(1).max(2000),
    /** The questions a rule may read or a question may depend on: key, wording, type and option values. */
    questions: z
        .array(z.strictObject({
        key: z.string(),
        text: z.string(),
        type: z.string(),
        options: z.array(z.strictObject({ value: z.string(), label: z.string() })).max(30),
    }))
        .max(600),
    /** Controls a score_change or finding may name. */
    controls: z.array(z.strictObject({ id: z.string(), name: z.string(), kill_switch: z.boolean() })).max(400),
    /** Keys already taken for this kind, so the agent suggests a new one. */
    taken_keys: z.array(z.string()).max(2000),
    /** A repair round: the previous draft and what failed validation. */
    previous: z.strictObject({ key: z.string(), body: z.unknown() }).nullable().default(null),
    issues: z
        .array(z.strictObject({ path: z.string(), message: z.string() }))
        .max(50)
        .default([]),
    provider: AgentProviderSpec.nullable().optional(),
});
/** The agent's proposal, in its envelope as `config:<kind>`. */
export const ConfigDraftProposal = z.strictObject({
    key: z.string().min(1).max(64),
    body: z.record(z.string(), z.unknown()),
    rationale: z.string().max(1000).default(''),
    assumptions: z.array(z.string().max(300)).max(10).default([]),
});
//# sourceMappingURL=config-drafter.js.map